import { createReducer, on } from '@ngrx/store'
import { appProgressbarClose, appProgressbarStart, appProgressbarUpdate } from '../../models/interfaces/app-progressbar-state.interface'
import * as WbsActions from './wbs.actions'
import { initialWbsState } from './wbs.state'

export const wbsReducer = createReducer(
   initialWbsState,
   on(
      WbsActions.exportGantt,
      WbsActions.exportWorkpackageList,
      WbsActions.exportDeliverableList,
      WbsActions.exportMilestoneList,
      WbsActions.exportRiskList,
      (state) => ({ ...state, exportProgress: appProgressbarStart() })
   ),
   on(
      WbsActions.exportGanttSuccess,
      WbsActions.exportWorkpackageListSuccess,
      WbsActions.exportDeliverableListSuccess,
      WbsActions.exportMilestoneListSuccess,
      WbsActions.exportRiskListSuccess,
      (state, { response }) => ({
         ...state,
         exportProgress: appProgressbarUpdate(state.exportProgress || appProgressbarStart(), response)
      })
   ),
   on(
      WbsActions.exportGanttFailed,
      WbsActions.exportWorkpackageListFailed,
      WbsActions.exportDeliverableListFailed,
      WbsActions.exportMilestoneListFailed,
      WbsActions.exportRiskListFailed,
      (state) => ({ ...state, exportProgress: appProgressbarClose('error') })
   ),
   on(WbsActions.closeExportProgress, (state) => ({ ...state, exportProgress: undefined })),

   on(WbsActions.loadWorkpackageList, (state) => ({ ...state, workpackages: undefined, isLoadingWorkpackages: true })),
   on(WbsActions.loadWorkpackageListSuccess, (state, { response }) => ({ ...state, workpackages: response, isLoadingWorkpackages: undefined })),
   on(WbsActions.loadWorkpackageListFailed, (state) => ({ ...state, isLoadingWorkpackages: undefined })),
   on(WbsActions.clearWorkpackageList, (state) => ({ ...state, workpackages: undefined, isLoadingWorkpackages: undefined })),

   on(WbsActions.loadDeliverableList, (state) => ({ ...state, deliverables: undefined, isLoadingDeliverables: true })),
   on(WbsActions.loadDeliverableListSuccess, (state, { response }) => ({ ...state, deliverables: response, isLoadingDeliverables: undefined })),
   on(WbsActions.loadDeliverableListFailed, (state) => ({ ...state, isLoadingDeliverables: undefined })),
   on(WbsActions.clearDeliverableList, (state) => ({ ...state, deliverables: undefined, isLoadingDeliverables: undefined })),

   on(WbsActions.loadMilestoneList, (state) => ({ ...state, milestones: undefined, isLoadingMilestones: true })),
   on(WbsActions.loadMilestoneListSuccess, (state, { response }) => ({ ...state, milestones: response, isLoadingMilestones: undefined })),
   on(WbsActions.loadMilestoneListFailed, (state) => ({ ...state, isLoadingMilestones: undefined })),
   on(WbsActions.clearMilestoneList, (state) => ({ ...state, milestones: undefined, isLoadingMilestones: undefined })),

   on(WbsActions.loadRiskList, (state) => ({ ...state, risks: undefined, isLoadingRisks: true })),
   on(WbsActions.loadRiskListSuccess, (state, { response }) => ({ ...state, risks: response, isLoadingRisks: undefined })),
   on(WbsActions.loadRiskListFailed, (state) => ({ ...state, isLoadingRisks: undefined })),
   on(WbsActions.clearRiskList, (state) => ({ ...state, risks: undefined, isLoadingRisks: undefined })),

   on(WbsActions.loadRisk, (state) => {
      return { ...state, riskActive: undefined, isLoadingRiskActive: true }
   }),
   on(WbsActions.loadRiskSuccess, (state, action) => {
      return { ...state, riskActive: action.response, isLoadingRiskActive: undefined }
   }),
   on(WbsActions.loadRiskFailed, (state) => {
      return { ...state, isLoadingRiskActive: undefined }
   }),
   on(WbsActions.clearRiskActive, (state) => {
      return { ...state, riskActive: undefined, isLoadingRiskActive: undefined }
   })
)
